import { makeStyles } from "@material-ui/core";
import { COLORS } from "config/theme/theme";

const priorityFeeFieldStyles = makeStyles(() => ({
    priorityFeeTextField: {
        borderRadius: "8px",
        backgroundColor: COLORS.WHITE,
    },
    disabledOutline: {
        borderColor: `${COLORS.MERCURY_LIGHT} !important`,
    },
    enabledOutline: {
        borderColor: `${COLORS.SILVERCHALICE} !important`,
    },
}));

export default priorityFeeFieldStyles;
